import React from "react";

import Cookies from "js-cookie";
import { useSelector } from "react-redux";
import FASTable from "../../../../../components/Tables/FASTable";
import { Loader } from "../../../../../components/Loader/Loader";
import format from "date-fns/format";
import { useTheme } from "../../../../../Themecontext/Themecontext";

export default function PaymentMonthWise({
  accountName,
  accountGroup,
  startDate,
  endDate,
}) {
  const { Colourdata } = useSelector((state) => state.ClientLogin);
  const { PayReceiptMonthdata } = useSelector(
    (state) => state.ReceivablePaybleSlice,
  );
  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;
  const Firm = Cookies.get("Firm");
  const YearId = Cookies.get("FinancialYear");

  const getRows = PayReceiptMonthdata?.Detail?.map((label, index) => ({
    chart: true,
    // srNumber: index + 1,
    AcName: label.AcName,
    AprAmount: label.AprAmount,
    MayAmount: label.MayAmount,
    JunAmount: label.JunAmount,
    JulAmount: label.JulAmount,
    AugAmount: label.AugAmount,
    SepAmount: label.SepAmount,
    OctAmount: label.OctAmount,
    NovAmount: label.NovAmount,
    DecAmount: label.DecAmount,
    JanAmount: label.JanAmount,
    FebAmount: label.FebAmount,
    MarAmount: label.MarAmount,
    TotalAmount: label.TotalAmount,
  }));

  const getColumns = [
    { label: "Chart", key: "charts", align: "center" },
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Ac Name",
      key: "AcName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Apr", key: "AprAmount", align: "right", format: "true" },
    { label: "May", key: "MayAmount", align: "right", format: "true" },
    { label: "Jun", key: "JunAmount", align: "right", format: "true" },
    { label: "Jul", key: "JulAmount", align: "right", format: "true" },
    { label: "Aug", key: "AugAmount", align: "right", format: "true" },
    { label: "Sep", key: "SepAmount", align: "right", format: "true" },
    { label: "Oct", key: "OctAmount", align: "right", format: "true" },
    { label: "Nov", key: "NovAmount", align: "right", format: "true" },
    { label: "Dec", key: "DecAmount", align: "right", format: "true" },
    { label: "Jan", key: "JanAmount", align: "right", format: "true" },
    { label: "Feb", key: "FebAmount", align: "right", format: "true" },
    { label: "Mar", key: "MarAmount", align: "right", format: "true" },

    { label: "Total Bal", key: "TotalAmount", align: "right", format: "true" },
  ];

  if (PayReceiptMonthdata === "no" || PayReceiptMonthdata === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-[#502000]">
        <Loader />
      </div>
    );
  }
  return (
    <div style={{ marginTop: "20px" }}>
      <div
        style={{
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
        }}
      >
        <div
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour4,
            color:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour11,
            padding: "14px",
            margin: 0,
          }}
        >
          <h2
            style={{
              fontSize: "18px",
              margin: 0,
              letterSpacing: "1px",
              fontWeight: "600",
            }}
          >
            PAYMENT MONTHWISE
          </h2>
        </div>

        <FASTable columns={getColumns} data={getRows} />
      </div>
    </div>
  );
}
